var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8738 16.6666H5.87381M27.5405 3.33325V9.99992M14.2071 3.33325V9.99992M13.8738 36.6666H27.8738C30.6741 36.6666 32.0742 36.6666 33.1438 36.1216C34.0846 35.6423 34.8495 34.8773 35.3288 33.9365C35.8738 32.867 35.8738 31.4669 35.8738 28.6666V14.6666C35.8738 11.8663 35.8738 10.4662 35.3288 9.39663C34.8495 8.45582 34.0846 7.69092 33.1438 7.21155C32.0742 6.66659 30.6741 6.66659 27.8738 6.66659H13.8738C11.0735 6.66659 9.67342 6.66659 8.60386 7.21155C7.66305 7.69092 6.89814 8.45582 6.41878 9.39663C5.87381 10.4662 5.87381 11.8663 5.87381 14.6666V28.6666C5.87381 31.4668 5.87381 32.867 6.41878 33.9365C6.89814 34.8773 7.66305 35.6423 8.60386 36.1216C9.67342 36.6666 11.0735 36.6666 13.8738 36.6666Z",
    stroke: "#278DEC",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.0b2696b8664b96efb1a28042b6af8099.svg";
export { ForwardRef as ReactComponent };